import script from "./RfidRogueLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidRogueLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidRogueLogsPage.vue?vue&type=style&index=0&id=3aae208e&lang=css"
import "./RfidRogueLogsPage.vue?vue&type=style&index=1&id=3aae208e&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aae208e"]])

export default __exports__